/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Ex_LungeInputs */

const en_features_ex_lunge = /** @type {(inputs: Features_Ex_LungeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dumbbell lunge`)
};

const pl_features_ex_lunge = /** @type {(inputs: Features_Ex_LungeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykroki z hantlami`)
};

/**
* | output |
* | --- |
* | "Dumbbell lunge" |
*
* @param {Features_Ex_LungeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_ex_lunge = /** @type {((inputs?: Features_Ex_LungeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Ex_LungeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_ex_lunge(inputs)
	return en_features_ex_lunge(inputs)
});